export const AdvancedColumnConfigLayoutType = Object.freeze({
  BASIC_LAYOUT: "BASIC_LAYOUT",
  TRAIN_LAYOUT: "TRAIN_LAYOUT"
});
